import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AreaModel } from '../area.model';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

export interface IAreaSelectParentAreaRights {
    items: AreaModel[];
}

@Component({
    selector: 'fi-area-select-parent-area-rights',
    templateUrl: './area-select-parent-area-rights.component.html',
    styleUrls: ['./area-select-parent-area-rights.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-area-select-parent-area-rights' },
    standalone: false,
})
export class AreaSelectParentAreaRightsComponent extends FiDialogsContentBase<IAreaSelectParentAreaRights, number> {
    parentAreaId: number;
    subAreasListData = new DropdownSettingsModelV2<AreaModel>({
        filterBy: 'Name',
    });

    ngOnInit() {
        this.setInitialData();
    }

    private setInitialData() {
        this.parentAreaId = this.data.items[0].Id;
        this.subAreasListData.setDataSet(this.data.items);
    }

    getResult(): number {
        return this.parentAreaId;
    }
}
